import moment from 'moment'

export const dateTimeFormatter = (date) => {
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export const moneyFormatter = (amount) => {
  return (!Number.isNaN(parseFloat(amount)) && Number.isFinite(amount) && amount.toFixed(2)) || '-'
}

export const signedMoneyAmountFormatter = (amount) => {
  return `${amount > 0 ? '+' : '-'} $${moneyFormatter(Math.abs(amount))}`
}
